/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import { images } from "../../config/images";
import { useAppDispatch } from "../../redux/Hooks/Hook";
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice";
import { NotificationCount } from "../../redux/Slice/NotificationCount/NotificationCountSlice";
import { GetProfile } from "../../redux/Slice/Profile/ProfileDetailSlice";
import { GetSettings } from "../../redux/Slice/Settings/SettingSlice";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { GetEnumsArr } from "../../redux/Slice/Users/EnumsSclice";
import { GetStates } from "../../redux/Slice/Users/StateListSlice";
import { GetNotificationCount } from "../../utilities/api/dashboard";
import { setupInstantNotifications } from "../../firebase";

const CustomerDashboard = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(AllSportsList({ isActive: "true" }))
        dispatch(GetEnumsArr())
        dispatch(AllFacilitiesList("true"))
        dispatch(GetStates())
        dispatch(GetProfile())
        dispatch(GetSettings())
        GetNotificationCount()?.then((res: any) => {
          dispatch(NotificationCount(`${res?.data?.count}`))
        })
    const initializeInstantNotifications = async () => {
      try {
        (window as any).dispatchNotificationCount = (count: string) => {
          dispatch(NotificationCount(count));
        };

        const token = await setupInstantNotifications();
        if (token) {
          localStorage.setItem("device-token", token);
        }
      } catch (error) {
        console.error("Error initializing notifications:", error);
      }
    };

    initializeInstantNotifications();

        document.body.classList.add("customer-page");
        return () => {
            document.body.classList.remove("customer-page");
          // Cleanup global function
          delete (window as any).dispatchNotificationCount;
        };
    }, [dispatch]);

    const handleCourt = () => {
        navigate("/customer-court-booking")

    }
    const handleCoaching = () => {
        navigate("/customer-coaching-booking")
    }
    const handleBooking = () => {
        navigate("/customer-booking-list")
    }
    const handleHistory = () => {
        navigate("/customer-booking-history")
    }

    return (
        <Container fluid className="g-0">
            <Row className="row-mb g-4 align-items-center justify-content-center">
                <Col lg={5} onClick={handleCourt}>
                    <Card className="border-0 customer-card">
                        <Card.Body>
                            <img src={images.customercourticon.default} height={120} alt="" />
                            <div className="align-items-center d-flex justify-content-between mt-4">
                                <span className="booking-name fs-5 fw-semibold">
                                    Book a Court
                                </span>
                                <span className="icon-right-arrow">
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={5} onClick={handleCoaching}>
                    <Card className="border-0 customer-card">
                        <Card.Body>
                            <img alt="" src={images.customercoachingicon.default} height={120} />
                            <div className="align-items-center d-flex justify-content-between mt-4">
                                <span className="booking-name fs-5 fw-semibold">
                                    Book a Coaching
                                </span>
                                <span className="icon-right-arrow">
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={5} onClick={handleBooking}>
                    <Card className="border-0 customer-card ">
                        <Card.Body>
                            <img alt="" src={images.customerbookingicon.default} height={120} />
                            <div className="align-items-center d-flex justify-content-between mt-4">
                                <span className="booking-name fs-5 fw-semibold">
                                    Bookings
                                </span>
                                <span className="icon-right-arrow">
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={5} onClick={handleHistory}>
                    <Card className="border-0 customer-card">
                        <Card.Body>
                            <img alt="" src={images.customerhistoryicon.default} height={120} />
                            <div className="align-items-center d-flex justify-content-between mt-4">
                                <span className="booking-name fs-5 fw-semibold">
                                    History
                                </span>
                                <span className="icon-right-arrow">
                                </span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </Container>
    )
}
export { CustomerDashboard }
